export const NAME = 'uistate';
export const PERSONS_GRIDNAME = 'personsGrid';
export const APPSETTINGS = "appSettings";
export const SHELLSETTINGS = "shellSettings";